import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { enumerated } from '~/prix/types/enumerated'
import sql from '~/prix/utils/sql'
import { creditRequestObject } from '../creditRequest/creditRequestObject'

export const creditDocumentStatus = enumerated({
  pending: 'Pendente',
  success: 'Sucesso',
  failed: 'Falhou',
})

export const creditDocumentObject = z.object({
  id: z.string().uuid(),
  creditRequestId: creditRequestObject.shape.id,
  privateFileId: z.string().uuid().nullish(),
  gcsIdentifier: z.string().nullish(),
  url: z.string().nullish(),
  fileName: z.string().nullish(),
  mimeType: z.string().nullish(),
  status: creditDocumentStatus,
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const creditDocumentCreateInputObject = creditDocumentObject
  .pick({
    id: true,
    creditRequestId: true,
    privateFileId: true,
    gcsIdentifier: true,
    url: true,
    fileName: true,
    mimeType: true,
    status: true,
  })
  .extend({
    id: creditDocumentObject.shape.id.nullish(),
    status: creditDocumentObject.shape.status.nullish(),
  })

export const creditDocumentUpdateInputObject = creditDocumentObject
  .pick({
    id: true,
    creditRequestId: true,
    privateFileId: true,
    gcsIdentifier: true,
    url: true,
    fileName: true,
    mimeType: true,
    status: true,
  })
  .partial()
  .required({ id: true })

export type CreditDocumentType = z.infer<typeof creditDocumentObject>

export const propertyMap = {
  id: sql`credit_document.id`,
  creditRequestId: sql`credit_document.credit_request_id`,
  privateFileId: sql`credit_document.private_file_id`,
  gcsIdentifier: sql`credit_document.gcs_identifier`,
  url: sql`credit_document.url`,
  fileName: sql`credit_document.file_name`,
  mimeType: sql`credit_document.mime_type`,
  status: sql`credit_document.status`,
  clientId: sql`credit_document.client_id`,
  insertUserId: sql`credit_document.insert_user_id`,
  editUserId: sql`credit_document.edit_user_id`,
  createdAt: sql`credit_document.created_at`,
  updatedAt: sql`credit_document.updated_at`,
  deletedAt: sql`credit_document.deleted_at`,
}

export default creditDocumentObject
